<article
  class="collection-card-mini"
  [class.mobile]="deviceService.isMobile()"
  [class.tablet]="deviceService.isTablet()"
  [class.infinity]="displayMode === 'infinity'"
  [class.lesson-collection]="displayMode === 'lesson-collection'"
  [class.content]="displayMode === 'content'"
  itemscope
  itemtype="https://schema.org/Product">
  <app-collection-meta *ngIf="meta" [collection]="collection"></app-collection-meta>
  <div *ngIf="!linkEnable" class="card-cover" [class.withUpgrade]="canUpgrade" (click)="onModalOpen()"></div>

  <ng-container [ngSwitch]="displayMode">
    <ng-container *ngSwitchCase="'default'">
      <ng-container *ngTemplateOutlet="defaultView"></ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="'infinity'">
      <ng-container *ngTemplateOutlet="infinityView"></ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="'lesson-collection'">
      <ng-container *ngTemplateOutlet="infinityView"></ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="'content'">
      <ng-container *ngTemplateOutlet="contentView"></ng-container>
    </ng-container>
  </ng-container>
</article>

<!-- Card templates -->

<ng-template #defaultView>
  <div class="default-view" [class.mobile]="deviceService.isMobile()">
    <ng-container *ngTemplateOutlet="toolsPanelRef"></ng-container>

    <div class="top-info-default">
      <div class="cover-block">
        <div
          *ngFor="let cover of multiCoverUrls; let i = index; trackBy: trackByFn"
          class="cover-item"
          [ngClass]="coverCssClasses(multiCoverUrls.length, i)">
          <on-ui-cover [cover]="coverImg(cover)"></on-ui-cover>
        </div>

        <div *ngIf="!multiCoverUrls?.length" class="cover-item">
          <on-ui-cover [cover]="noCover"></on-ui-cover>
        </div>
      </div>
      <a [routerLink]="collectionUrl || editCollectionUrl" [attr.title]="fullTitle" class="info">
        <p class="subject-wrap" *ngIf="collection.subject?.title">
          <span class="subject">{{ collection.subject?.title }}</span>
          <ng-template [ngIf]="subjectIsNative">
            <span class="native">{{ 'library.user-service-card.native' | customLocale }}</span>
          </ng-template>
        </p>
        <div class="title">{{ collection.title }}</div>
        <div class="excerpt">{{ collection.excerpt }}</div>
        <div class="sub-info">
          <span class="materials">{{ 'collections.text.items' | customLocale }} {{ collection.stats?.total }}</span>
        </div>
        <ng-template [ngIf]="!deviceService.isMobile()">
          <app-author-info [user]="collection.author"></app-author-info>
        </ng-template>
      </a>
    </div>
    <ng-template [ngIf]="deviceService.isMobile()">
      <div class="description">{{ collection.description }}</div>
      <app-author-info [user]="collection.author"></app-author-info>
      <div class="center-block">
        <ng-template [ngIf]="canBuy || isAuthor">
          <div class="price-block">
            <div class="price-wrap">
              <span class="price">
                {{ getFormattedPrice(selectedLicensePrice) | async }}
              </span>
              <div
                class="icon-see-prices"
                [appPopover]="pricesPopoverContent"
                [popoverOnly]="true"
                [position]="position">
                ?
              </div>
            </div>
          </div>
        </ng-template>

        <ng-template [ngIf]="purchasedLicense">
          <div class="access-block">
            <div class="info-part">
              <app-icon class="access-icon" icon="key"></app-icon>
              <span
                class="type-access"
                [innerHtml]="
                  'collections.text.license-type-label'
                    | customLocale
                      : {
                          label:
                            '<span class=\'access-type-text\'>' +
                            (getLicenseName(purchasedLicense) | customLocale) +
                            '</span>'
                        }
                ">
              </span>
            </div>
            <on-ui-button
              *ngIf="canUpgrade"
              class="poutline"
              label="collections.actions.upgrade-license"
              (onclick)="showLicenseSelector()">
            </on-ui-button>
          </div>
        </ng-template>
      </div>
      <div class="action-block">
        <on-ui-button
          class="poutline"
          label="collections.actions.details"
          [iconPosition]="'after'"
          (click)="onModalOpen()">
          <app-icon [width]="10" [height]="10" file="chevron" icon="down"></app-icon>
        </on-ui-button>

        <ng-template [ngIf]="canBuy">
          <on-ui-button class="secondary" label="collections.actions.buy" (onclick)="showLicenseSelector()">
          </on-ui-button>
        </ng-template>
      </div>
    </ng-template>
  </div>
</ng-template>

<ng-template #infinityView>
  <div class="top-info">
    <div class="top-wrap">
      <a [routerLink]="accountRoute" class="author-wrap">
        <div class="avatar-wrap">
          <ng-template [ngIf]="authorAvatarUrl" [ngIfElse]="noAvatar">
            <img [src]="authorAvatarUrl" [attr.alt]="authorName" [attr.title]="authorName" class="avatar" />
          </ng-template>
          <ng-template #noAvatar>
            <app-icon [attr.alt]="authorName" [attr.title]="authorName" class="avatar" icon="guest"></app-icon>
          </ng-template>
        </div>
        <div class="info-collection">
          <span class="author-name">{{ authorName }}</span>
          <span class="time">{{ collectionDate | dfnsFormatDistanceToNow : { addSuffix: true } }}</span>
        </div>
      </a>
      <ng-container *ngTemplateOutlet="toolsPanelRef"></ng-container>
    </div>
    <div class="collection-info">
      <a [routerLink]="collectionUrl || editCollectionUrl" class="cover-wrap">
        <ng-container *ngTemplateOutlet="coverBlock"></ng-container>
      </a>
      <a [routerLink]="collectionUrl || editCollectionUrl" [attr.title]="fullTitle" class="info-block">
        <p class="subject-wrap" *ngIf="collection.subject?.title">
          <span class="subject">{{ collection.subject?.title }}</span>
          <ng-template [ngIf]="subjectIsNative">
            <span class="native normal">{{ 'library.user-service-card.native' | customLocale }}</span>
          </ng-template>
        </p>
        <div class="title">{{ collection.title }}</div>
        <div *ngIf="!deviceService.isMobile()" class="excerpt">{{ collection.excerpt }}</div>
        <span class="materials">{{ 'collections.text.items' | customLocale }} {{ collectionStatsTotal }}</span>
      </a>
    </div>
  </div>

  <div class="actions-block">
    <div class="price-wrap">
      <div class="price-text">
        <ng-template [ngIf]="collection.discount">
          <div class="discount-wrap">
            <span class="price-without-discount">{{ getFormattedPrice(selectedLicensePrice) | async }}</span>
            <span class="discount">{{
              'collections.text.discount' | customLocale : { discount: collectionDiscount }
            }}</span>
          </div>
        </ng-template>
        <ng-template [ngIf]="selectedLicensePrice">
          <div class="see-price-wrap">
            <span class="price">{{ getFormattedPrice(selectedLicensePrice, collection.discount) | async }}</span>
            <div class="icon-see-prices" [appPopover]="pricesPopoverContent" [popoverOnly]="true" [position]="position">
              ?
            </div>
          </div>
        </ng-template>
      </div>
    </div>

    <ng-container *ngIf="collectionUrl; else editRef">
      <on-ui-button
        class="poutline"
        label="collections.actions.details"
        [iconPosition]="'after'"
        [routerLink]="collectionUrl">
        <app-icon width="12" height="8" file="chevron" icon="down"></app-icon>
      </on-ui-button>
    </ng-container>

    <ng-template #editRef>
      <on-ui-button
        *ngIf="editCollectionUrl"
        class="poutline"
        label="collections.actions.edit"
        [routerLink]="editCollectionUrl">
      </on-ui-button>
    </ng-template>
  </div>

  <div class="extra-actions-block">
    <ng-content select="[card-actions]"></ng-content>
  </div>
</ng-template>

<ng-template #contentView>
  <div class="top-info">
    <div class="collection-info">
      <div class="cover-wrap">
        <ng-container *ngTemplateOutlet="coverBlock"></ng-container>
      </div>
      <div [attr.title]="fullTitle" class="info-block">
        <i class="subject-wrap" *ngIf="collection.subject?.title">
          <span class="subject">{{ collection.subject?.title }}</span>
          <ng-template [ngIf]="subjectIsNative">
            <span class="native normal">{{ 'library.user-service-card.native' | customLocale }}</span>
          </ng-template>
        </i>
        <div class="title">{{ collection.title }}</div>
        <span class="materials">{{ 'collections.text.items' | customLocale }} {{ collection.stats?.total }}</span>
        <span class="status" *ngIf="moderationStatus" [ngClass]="moderationStatus.class"
          >{{ moderationStatus.message | customLocale }}
        </span>
      </div>
      <ng-container *ngIf="collection.changed_at; else notArchivedCollectionActions">
        <div class="links-block">
          <a *ngIf="isAuthor" (click)="restore()">{{ 'collections-constructor.actions.restore' | customLocale }}</a>
        </div>
      </ng-container>
      <ng-template #notArchivedCollectionActions>
        <div class="links-block" [class.disabled]="isOnModeration">
          <a *ngIf="isApproved && isAuthor" (click)="unPublish()">{{
            'collections.actions.remove-from-publication' | customLocale
          }}</a>
          <!--Hide for now, cause valid param works incorrect-->
          <!--<a *ngIf="canBePublished" (click)="publish()">{{ 'collections-constructor.actions.publish' | customLocale }}</a>-->
          <a *ngIf="isAuthor" [routerLink]="editCollectionUrl" class="menu-item">{{
            'collections.actions.edit' | customLocale
          }}</a>
          <a *ngIf="isAuthor" (click)="onToggleDeleteAlert()">{{ 'collections.actions.delete' | customLocale }}</a>
        </div>
      </ng-template>
    </div>
  </div>
</ng-template>

<!-- Blocks templates -->

<ng-template #priceForMobile>
  <div class="price-for-mobile">
    <ng-template [ngIf]="collection.discount">
      <span class="price-without-discounts">
        {{ getFormattedPrice(selectedLicensePrice, collection.discount) | async }}
      </span>
    </ng-template>
    <div class="price-wrap">
      <span class="price">{{ getFormattedPrice(selectedLicensePrice) | async }}</span>
      <ng-template [ngIf]="collection.discount">
        <div class="discount">
          {{ 'collections.text.discount' | customLocale : { discount: collectionDiscount } }}
        </div>
      </ng-template>
      <div class="icon-see-prices" [appPopover]="pricesPopoverContent" [popoverOnly]="true" [position]="position">
        ?
      </div>
    </div>
  </div>
</ng-template>

<ng-template #ratingWrap>
  <app-rating [stats]="authorStats"></app-rating>
</ng-template>

<app-alert type="error" *ngIf="isDeleteAlertOpened" (closed)="onToggleDeleteAlert()">
  <ng-container alert-title>{{ 'collections-constructor.delete-confirmation.title' | customLocale }}</ng-container>
  <ng-container alert-body>
    <div [innerHTML]="'collections-constructor.delete-confirmation.text' | customLocale"></div>
  </ng-container>
  <ng-container alert-buttons>
    <on-ui-button
      class="primary outline"
      label="collections-constructor.delete-confirmation.cancel"
      (onclick)="onToggleDeleteAlert()">
    </on-ui-button>
    <on-ui-button
      class="primary"
      label="collections-constructor.delete-confirmation.delete"
      (onclick)="onDeleteCollection()">
    </on-ui-button>
  </ng-container>
</app-alert>

<ng-template #toolsPanelRef>
  <div class="tools-panel">
    <div class="tools-box">
      <app-bookmark [item]="collection" [type]="'collection'" (favoriteChanged)="onFavoriteChanged()"></app-bookmark>
      <on-ui-card-menu>
        <div *ngIf="!isAuthor" (click)="openComplainForm()" class="menu-item">{{ 'users.complain' | customLocale }}</div>
        <div *ngIf="isAuthor" class="menu-item">
          <a [routerLink]="editCollectionUrl" class="menu-item">{{ 'collections.actions.menu-edit' | customLocale }}</a>
        </div>
        <div *ngIf="isAuthor" class="menu-item">
          <span class="menu-item" (click)="onToggleDeleteAlert()">{{
            'collections.actions.menu-remove' | customLocale
          }}</span>
        </div>
        <div *ngIf="!isAuthor && isModerator" class="menu-item">
          <a class="menu-item warn" [routerLink]="editCollectionUrl">[⚠️] Edit</a>
        </div>
        <div *ngIf="collection.purl" class="menu-item">
          <a class="menu-item warn" [href]="collection.purl">[⚠️] Panel</a>
        </div>
      </on-ui-card-menu>
    </div>
  </div>
</ng-template>

<ng-template #coverBlock>
  <div class="cover-block" [class.no-cover]="!multiCoverUrls.length">
    <ng-template [ngIf]="multiCoverUrls.length" [ngIfElse]="noCover">
      <div
        *ngFor="let coverItem of multiCoverUrls; let i = index; trackBy: trackByFn"
        class="cover-item"
        [ngClass]="coverCssClasses(multiCoverUrls.length, i)">
        <ng-template [ngIf]="isBrowser" [ngIfElse]="noBrowser">
          <img [lazyLoad]="coverItem" [alt]="fullTitle" [title]="fullTitle" class="cover" />
        </ng-template>
        <ng-template #noBrowser>
          <img [src]="coverItem" [alt]="fullTitle" [title]="fullTitle" class="cover" />
        </ng-template>
      </div>
    </ng-template>
    <ng-template #noCover>
      <app-icon icon="no-cover"></app-icon>
    </ng-template>
  </div>
</ng-template>

<ng-template #pricesPopoverContent>
  <app-collection-license-prices [collection]="collection"></app-collection-license-prices>
</ng-template>

<app-modal
  *ngIf="complainFormOpened && deviceService.isDesktop()"
  (closed)="closeComplainForm()"
  canClose="true"
  middle="true">
  <app-modal-body>
    <app-complaint-form [type]="'content'" (cancel)="closeComplainForm()"></app-complaint-form>
  </app-modal-body>
</app-modal>

<app-mobile-modal
  *ngIf="complainFormOpened && !deviceService.isDesktop()"
  [titleVisible]="false"
  (closed)="closeComplainForm()">
  <app-mobile-modal-body>
    <app-complaint-form [type]="'content'" (cancel)="closeComplainForm()"></app-complaint-form>
  </app-mobile-modal-body>
</app-mobile-modal>

<app-modal
  *ngIf="!deviceService.isMobile() && buyCollectionModal"
  [schedule]="deviceService.isTablet()"
  (closed)="closeBuyCollectionModal()">
  <app-modal-body>
    <app-payment-checkout-wizard
      [content]="collection"
      [user]="user"
      (succeed)="updateCollection()"
      (closed)="closeBuyCollectionModal()">
    </app-payment-checkout-wizard>
  </app-modal-body>
</app-modal>

<app-mobile-modal
  *ngIf="deviceService.isMobile() && buyCollectionModal"
  [titleVisible]="false"
  [withCloseButton]="true"
  [customTitle]="'collections.text.license' | customLocale"
  (closed)="closeBuyCollectionModal()">
  <app-mobile-modal-body>
    <app-payment-checkout-wizard
      [content]="collection"
      [user]="user"
      (succeed)="updateCollection()"
      (closed)="closeBuyCollectionModal()">
    </app-payment-checkout-wizard>
  </app-mobile-modal-body>
</app-mobile-modal>
